import React, { useRef, useState } from 'react';

import { GoogleGenerativeAI } from '@google/generative-ai';
import { Camera } from "react-camera-pro";
import mixpanel from 'mixpanel-browser';

/* UI */
import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Card from 'react-bootstrap/Card';
import Container from 'react-bootstrap/Container';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Form from 'react-bootstrap/Form';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';

const genAI = new GoogleGenerativeAI('AIzaSyAhX-Gua6iVlKxnW_PWqgLMndgjYsjID6c');
const model = genAI.getGenerativeModel({ model: "gemini-1.5-flash" });

// Near entry of your product, init Mixpanel
mixpanel.init("1c2641287a015eaab51f5fcded3e814b", {
    debug: true,
    track_pageview: true,
    persistence: "localStorage",
});

const Home = () => {
    const [Mode, setMode] = useState("text");
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState(null);
    const [aiResponse, setResponse] = useState(null);
    const [longResponse, setLongResponse] = useState(null);

    const camera = useRef(null);
    const [image, setImage] = useState(null);

    const handleChangeSearch = (e) => {
        setSearch(e.target.value);
    }

    const aiTextRun = async () => {
        mixpanel.track('Query Text', {
            'Query Type': 'Text',
            'Query Value': search
        });

        setLoading(true);
        setResponse(null);
        setLongResponse(null);
        const prompt = `Is this brand ${search} a Canadian brand? Please only provide a YES CANADIAN or NOT CANADIAN answer. If it does not sound like a brand name, please reply IT IS NOT A BRAND NAME.`;
        const result = await model.generateContent(prompt);
        const response = await result.response;
        const text = response.text();
        setResponse(text);

        if (text.includes("NOT CANADIAN")) {
            const altResponse = await aiTextAltRun();
        }

        setLoading(false);
    }

    const aiTextLongRun = async () => {
        setLoading(true);
        const prompt = `Is this brand ${search} a Canadian brand? Please provide supporting sources and evidences.`;
        const result = await model.generateContent(prompt);
        const response = await result.response;
        const text = response.text();
        setLongResponse(text);
        setLoading(false);
    }

    const aiTextAltRun = async () => {
        //setLoading(true);
        setLongResponse(null);
        const prompt = `Are there alternative to ${search}? Please provide a list of Canadian brand names. I only want the names, no explainations. Please exclude brands that are owned by USA.`;
        const result = await model.generateContent(prompt);
        const response = await result.response;
        const text = response.text();

        //const newText = text.replaceAll("*", "\n");
        setLongResponse(text);
        //setLoading(false);
    }

    const aiImageRun = async () => {

    }

    const handleClick = () => {
        if (search) {
            aiTextRun();
        } else {
            alert("Nothing in search");
        }
    }

    return (
        <>
            <Container style={{ padding: '1.5rem' }}>
                <h1>Is It 🍁?</h1>
                <p>Built with love using <a href="https://react.dev/">ReactJS</a> & <a href="https://gemini.google.com">Gemini</a> by <a href="https://hwlo.ca">hwlo.ca</a></p>

                <Tabs defaultActiveKey="text" id="tabs" className="mb-3" fill>
                    <Tab eventKey="text" title="Text">
                        <Card style={{ width: '100%', padding: '1.5rem' }}>
                            <Card.Title>Ask by Text</Card.Title>
                            <Card.Body>
                                <Form.Control type='text' id='inputText' placeholder='Enter Brand Name Here' onChange={(e) => handleChangeSearch(e)} />
                                <Button style={{ margin: "1rem" }} onClick={() => handleClick()}>Search</Button>
                            </Card.Body>
                        </Card>
                    </Tab>
                    <Tab eventKey="camera" title="Photo (Coming Soon)" disabled>
                        <Card style={{ width: '100%', padding: '1.5rem' }}>
                            <Card.Title>Ask by Photo</Card.Title>
                            <Card.Body>
                                {
                                    image === null
                                        ?
                                        <>
                                            <div style={{ display: "block", width: "640px", textAlign: "center", margin: "1px auto" }}>
                                                {/* <Camera ref={camera} aspectRatio={16 / 9} /> */}
                                            </div>
                                            <Button style={{ margin: "1rem" }} onClick={() => setImage(camera.current.takePhoto())}>Take Photo 📷</Button>
                                        </>
                                        :
                                        <>
                                            <div style={{ display: "block", width: "640px", textAlign: "center", margin: "1px auto" }}>
                                                <img src={image} alt='Photo Preview' />
                                            </div>
                                            <ButtonGroup>
                                                <Button style={{ margin: "1rem" }} onClick={() => setImage(null)}>Retake Photo ❌</Button>
                                                <Button style={{ margin: "1rem" }} onClick={() => { }}>Use Photo ✅</Button>
                                            </ButtonGroup>
                                        </>
                                }
                            </Card.Body>
                        </Card>
                    </Tab>
                </Tabs>
                {
                    aiResponse || loading === true
                        ?
                        loading === true
                            ?
                            <Card style={{ width: '100%', padding: '1.5rem', margin: '1.5em 0px' }}>
                                <Card.Title>Response</Card.Title>
                                <Card.Body>Loading...</Card.Body>
                            </Card>
                            :
                            <Card style={{ width: '100%', padding: '1.5rem', margin: '1.5rem 0px' }}>
                                <Card.Title>Response</Card.Title>
                                <Card.Body>
                                    <h1>{aiResponse}</h1>
                                    {
                                        longResponse
                                        &&
                                        <Alert variant='info'>
                                            <h5>Possible Alternatives:</h5>
                                            {longResponse}
                                        </Alert>
                                    }
                                </Card.Body>
                            </Card>
                        :
                        <></>
                }
            </Container>
            <Container fluid>

            </Container>
        </>
    );
};

export default Home;